import { render, staticRenderFns } from "./make-models.vue?vue&type=template&id=33bd85f2&"
import script from "./make-models.vue?vue&type=script&lang=js&"
export * from "./make-models.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports